class TesterIdReportController {
    constructor($browser, $window, $location, toastr, moment, ngProgressFactory, UserDetailsApi, SettingsService, ReportServiceApi, ReportUtilityServiceApi, ReportUtils) {
        this.$onInit = () => {
            this.state = {
                userDetails: null,
                selectedTester: { Id: 0, Name: 'Unknown' },
                selectedSim: { Id: 0, Name: 'Unknown' },
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                showReport: false,
                showTesters: true
            };
            this.data = {
                testerIdReports: [],
                testers: [],
                testerSims: []
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.hide = true;
            this.columnDefs = [
                {
                    headerName: 'Id',
                    field: 'Id',
                    width: 65,
                    minWidth: 65,
                    maxWidth: 65,
                    hide: this.hide
                },
                {
                    headerName: 'UserId',
                    field: 'UserId',
                    width: 65,
                    minWidth: 65,
                    maxWidth: 65,
                    hide: this.hide
                },
                {
                    headerName: 'User',
                    field: 'Description',
                    width: 250,
                    minWidth: 120,
                    maxWidth: 250,
                    sort: 'asc'
                },
                // { headerName: 'UserName', field: 'UserName', cellRenderer: nameRenderer, width: 100 },
                {
                    headerName: 'SimId',
                    field: 'SimId',
                    width: 75,
                    minWidth: 60,
                    maxWidth: 75,
                    filter: 'number',
                    hide: this.hide
                },
                {
                    headerName: 'Simulator Name',
                    field: 'SimName',
                    minWidth: 150
                },
                {
                    headerName: 'Terminal Id',
                    field: 'TerminalUid',
                    width: 120,
                    maxWidth: 120,
                    minWidth: 120
                },
                {
                    headerName: 'Merchant Id',
                    field: 'MerchantUid',
                    width: 150,
                    maxWidth: 170,
                    minWidth: 150
                },
                {
                    headerName: 'External Source Id',
                    field: 'ExternalSourceId',
                    minWidth: 110,
                    cellRenderer: this.xmlCellRenderer
                }
            ];
            this.rowCount = '0';
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.testerIdReport = {
                Id: 0,
                Name: '',
                Description: 'Tester Id Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.showReport = true;
            });
            this.UserDetailsApi.get().then((data) => {
                this.state.userDetails = data; // setup our user details
                const req = {
                    UserId: -1,
                    SimId: -1,
                    TestSuiteId: -1
                };
                this.ReportServiceApi.getTesterIdReport(req).then((response) => {
                    this.traceProgress.complete();
                    this.data.testerIdReports = response.data;
                    // Create a list of testers and select the first one
                    this.data.testers = this.ReportService.testers(this.data.testerIdReports) || [{ Id: 0, Name: 'No testers available' }];
                    this.state.selectedTester = this.data.testers[0];
                    this.selectTester(this.data.testers[0]);
                    this.state.showTesters = true;
                    // Get the data
                    this.gridOptions.api.setRowData(this.data.testerIdReports);
                    this.gridOptions.api.sizeColumnsToFit();
                    return;
                });
            }, () => {
                this.traceProgress.complete();
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('TesterIdReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.testerIdReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.xmlCellRenderer = (row) => {
            let rowData = row.data;
            if (rowData.ExternalSourceId === null ||
                rowData.ExternalSourceId === 'undefined') {
                return '';
            }
            const xml = '<p>' + this.xmlReplace(rowData.ExternalSourceId) + '</p>';
            return xml;
        };
        this.xmlReplace = (str) => {
            const text = String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/&lt;Arguments&gt;/g, '&lt;Arguments&gt;<br />')
                .replace(/&lt;\/Arguments&gt;/g, '<br />&lt;/Arguments&gt;')
                .replace(/&lt;controlport&gt;/g, '<br />&lt;controlport&gt;');
            return text;
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.onModelUpdated = () => {
            const model = this.gridOptions.api.getModel();
            const processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
        };
        this.selectTester = (tester) => {
            if (this.data.testers === undefined || this.data.testers[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedTester = this.data.testers[0];
            if (!_.isNil(tester)) {
                this.state.selectedTester = tester;
            }
            let sims = this.ReportService.testerSims(this.data.testerIdReports, this.state.selectedTester.Id);
            this.data.testerSims = sims;
            this.selectSim(sims[0]);
        };
        this.selectSim = (sim) => {
            if (_.isNil(sim)) {
                sim = { Id: 0, Name: 'All Sims' };
            }
            this.state.selectedSim = sim;
            const data = this.data.testerIdReports;
            const testerId = this.state.selectedTester.Id;
            const filteredData = this.ReportService.testerSimReport(data, testerId, sim.Id);
            this.gridOptions.api.setRowData(filteredData);
        };
        this.exportCsv = () => {
            const Description = this.state.selectedTester.Name;
            const simName = this.state.selectedSim.Name;
            const title = [
                Description,
                '-',
                simName,
                '-' + this.testerIdReport.Description + '.csv'
            ].join('');
            const reportName = this.ReportService.addDateToTitle(title);
            let params = {
                allColumns: false,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.buildColumnDefinition = () => {
            let columnDefStr = '';
            for (let idx = 0; idx < this.gridOptions.columnDefs.length; idx++) {
                let colName = this.gridOptions.columnDefs[idx].headerName;
                let colWidth = 100; // TODO: Need a default if cannot find a suitable column width
                let hide = false;
                let fieldName = '';
                const def = this.gridOptions.columnDefs[idx];
                if (def.field !== undefined) {
                    fieldName = def.field;
                }
                if (def.width !== undefined) {
                    colWidth = def.width;
                }
                else if (def.minWidth !== undefined) {
                    colWidth = def.minWidth;
                }
                else if (def.maxWidth !== undefined) {
                    colWidth = def.maxWidth;
                }
                if (def.hide !== undefined) {
                    hide = def.hide;
                }
                if (hide === false) {
                    columnDefStr = columnDefStr +
                        colName + ':' + fieldName + ':' + colWidth.toString() + ',';
                }
            }
            return columnDefStr;
        };
        this.exportPdf = () => {
            const title = [
                this.state.selectedTester.Name,
                '-',
                this.state.selectedSim.Name,
                '-Id Report'
            ].join('');
            const reportName = this.ReportService.addDateToTitle(title) + '.pdf';
            let columnDefStr = this.buildColumnDefinition();
            let sortModel = this.gridOptions.api.getSortModel();
            let sortDef = '';
            // Sometimes sortModel[0] is undefined, if this happens use the
            // default sort order
            if ((sortModel === undefined) ||
                (sortModel[0] === undefined) ||
                (sortModel[0].colId === undefined)) {
                sortDef = 'Description:asc';
            }
            else {
                sortDef = sortModel[0].colId + ':' + sortModel[0].sort;
            }
            // TODO: Wrap up all these parameters in json
            let url = ['api/Report/GetTesterIdReportPdf?',
                'UserId=',
                this.state.selectedTester.Id,
                '&SimId=',
                this.state.selectedSim.Id,
                '&DocumentName=',
                reportName,
                '&Header=',
                title,
                '&ColumnDefinitions=',
                columnDefStr,
                '&SortDefinition=',
                sortDef
            ].join('');
            this.window.open(url, '_blank' // <- This is what makes it open in a new window, Workaround for IE.
            );
            return;
        };
        this.ReportServiceApi = ReportServiceApi;
        this.ReportService = ReportUtilityServiceApi;
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.toastr = toastr;
        this.moment = moment;
        this.ngProgressFactory = ngProgressFactory;
        this.UserDetailsApi = UserDetailsApi;
        this.SettingsService = SettingsService;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('testerIdReport', {
    templateUrl: 'Scripts/App/partials/Reports/tester-id-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: TesterIdReportController
});
